
import {
  call,
  put,
  takeLatest,
  takeEvery
} from "redux-saga/effects";

import { authorizedRequest } from "../../utils/api";
import { API_PROPERTIES } from "../../constants/apiRoutes";
import { ToastSuccess, ToastError } from "../../components/Global/Toasts/Toasty";
import { makePayload, generateDefaultActions, callbackSaga, requestSaga } from "../utils/helpers";

export const PROPERTY_FETCH_REQUEST = "PROPERTY_FETCH_REQUEST";
export const PROPERTY_FETCH_SUCCESS = "PROPERTY_FETCH_SUCCESS";
export const PROPERTY_FETCH_FAILURE = "PROPERTY_FETCH_FAILURE";

export const UPDATE_PROPERTY = generateDefaultActions("UPDATE_PROPERTY");
export const updateProperty = payload => makePayload(UPDATE_PROPERTY.value, payload);
function* updatePropertySaga(payload) {
  const url = `/updateProperty/${payload.id}`;
  const filteredPayload = {
    ...payload
  };
  delete filteredPayload.type;
  const requestSaga = callbackSaga(payload.callback);
  yield requestSaga(UPDATE_PROPERTY, url, "POST", filteredPayload);
}

export const CREATE_PROPERTY = generateDefaultActions("CREATE_PROPERTY");
export const createProperty = payload => makePayload(CREATE_PROPERTY.value, payload);
function* createPropertySaga(payload) {
  const url = `/deals/${payload.dealId}/createProperty`;
  const filteredPayload = {
    ...payload
  };
  delete filteredPayload.dealId;
  delete filteredPayload.id;
  delete filteredPayload.type;
  const requestSaga = callbackSaga(payload.callback);
  yield requestSaga(CREATE_PROPERTY, url, "POST", filteredPayload);
}

export const DELETE_PROPERTY = generateDefaultActions("DELETE_PROPERTY");
export const deleteProperty = payload => makePayload(DELETE_PROPERTY.value, payload);
function* deletePropertySaga(payload) {
  const url = `/deleteProperty/${payload.id}`;
  const requestSaga = callbackSaga(payload.callback);
  yield requestSaga(DELETE_PROPERTY, url, "POST");
}

export const GET_MOST_RECENT_PROJECTION_OF_PROPERTY = generateDefaultActions("GET_MOST_RECENT_PROJECTION_OF_PROPERTY");
export const getMostRecentProjectionOfProperty = payload => makePayload(GET_MOST_RECENT_PROJECTION_OF_PROPERTY.value, payload);
function* getMostRecentProjectionOfPropertySaga(payload) {
  const url = "/getMostRecentProjectionOfProperty";
  yield requestSaga(GET_MOST_RECENT_PROJECTION_OF_PROPERTY, url, "POST", payload);
}

export const FETCH_PROPERTIES_WITH_PROJECTIONS = generateDefaultActions("FETCH_PROPERTIES_WITH_PROJECTIONS");
export const fetchPropertiesWithprojections = payload => makePayload(FETCH_PROPERTIES_WITH_PROJECTIONS.value, payload);
function* fetchPropertiesWithprojectionsSaga(payload) {
  const url = "/getPropertiesAndProjectionsOfDeal";
  yield requestSaga(FETCH_PROPERTIES_WITH_PROJECTIONS, url, "POST", payload);
}

export const SAVE_CUSTOM_PROJECTION = generateDefaultActions("SAVE_CUSTOM_PROJECTION");
export const saveCustomProjection = payload => makePayload(SAVE_CUSTOM_PROJECTION.value, payload);
function* saveCustomProjectionSaga(payload) {
  const url = "/saveCustomProjection";
  yield requestSaga(SAVE_CUSTOM_PROJECTION, url, "POST", payload);
}

export const CLEAR_PROJECTIONS = generateDefaultActions("CLEAR_PROJECTIONS");
export const clearProjections = payload => makePayload(CLEAR_PROJECTIONS);
function* clearProjectionsSaga(payload) {}

const initialState = {
  propertyProjections: {},
  deal: null
};

export default function propertyReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_PROPERTY.success:
      ToastSuccess("Rerunning calculations. Check back in 10 minutes.");

      return state;
    case PROPERTY_FETCH_SUCCESS:
      return payload;
    case GET_MOST_RECENT_PROJECTION_OF_PROPERTY.success: {
      const newProjections = state.propertyProjections;
      newProjections[payload.propertyId] = payload.result;

      return { ...state, propertyProjections: newProjections };
    }
    case FETCH_PROPERTIES_WITH_PROJECTIONS.success:
      return { ...state, deal: { properties: payload.result, name: payload.dealName, targetedClosing: payload.targetedClosing } };
      break;
    case CLEAR_PROJECTIONS:
      return { ...state, propertyProjections: {}, deal: null };
      break;
    default:
      return state;
  }
}

/**
 * Get all propertys
 * @return {Object} Action
 */
export function fetchProperties() {
  return {
    type: PROPERTY_FETCH_REQUEST
  };
}

export function propertyFetchSuccess(payload) {
  return {
    type: PROPERTY_FETCH_SUCCESS,
    payload
  };
}

function propertyFetchFailure(payload) {
  return {
    type: PROPERTY_FETCH_FAILURE,
    payload
  };
}

// Saga
function* fetchSaga() {
  try {
    const response = yield call(authorizedRequest, API_PROPERTIES);
    yield put(propertyFetchSuccess(response));
  } catch (error) {
    yield put(propertyFetchFailure(error));
    ToastError(error.message);
  }
}

export function* propertySaga() {
  yield takeLatest(PROPERTY_FETCH_REQUEST, fetchSaga);
  yield takeLatest(UPDATE_PROPERTY.value, updatePropertySaga);
  yield takeLatest(CREATE_PROPERTY.value, createPropertySaga);
  yield takeLatest(DELETE_PROPERTY.value, deletePropertySaga);
  yield takeEvery(GET_MOST_RECENT_PROJECTION_OF_PROPERTY.value, getMostRecentProjectionOfPropertySaga);
  yield takeLatest(FETCH_PROPERTIES_WITH_PROJECTIONS.value, fetchPropertiesWithprojectionsSaga);
  yield takeLatest(SAVE_CUSTOM_PROJECTION.value, saveCustomProjectionSaga);
  yield takeLatest(CLEAR_PROJECTIONS.value, clearProjectionsSaga);
}
